
let defaultState = {
    assetTypes: [],
    businessTypes: [],
    improvements: []
}



let indicativeOptionData = (state = defaultState, action = {}) => {

    switch (action.type) {

        case 'UPDATE_OPTION_DATA':
            return {...state, ...action.data}

        default:
            return state
    }
}


export default indicativeOptionData;
